import { useEffect, useState, useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { SignalRService } from '@/services/signalr.service';
import { axiosInstance } from '@/services/axios.service';
import { ENDPOINTS } from '@/constants/endpoints';
import _ from 'lodash';

const InsightsPdfViewer = () => {
	const [pdfUrl, setPdfUrl] = useState<string>('');
	const [isLoading, setIsLoading] = useState(true);
	const [searchParams] = useSearchParams();

	const loadPdf = useCallback(async () => {
		try {
			setIsLoading(true);

			// Get parameters from URL query string
			const start = searchParams.get('Start');
			const end = searchParams.get('End');
			const groupBy = searchParams.get('GroupBy') || 'day';
			const rangeName = searchParams.get('RangeName') || "";

			// Build request payload
			const requestPayload = start && end
				? { Start: start, End: end, GroupBy: groupBy, RangeName: rangeName }
				: { "Start": "2025-12-05T03:00:00.000Z", "End": "2025-12-12T16:43:27.739Z", "GroupBy": "day" };

			const response = await axiosInstance.post(
				ENDPOINTS['/api/payments/ExportInsights'],
				//Today
				//{ "Start": "2025-12-12T03:00:00.000Z", "End": "2025-12-12T15:35:04.836Z", "GroupBy": "hour" },
				// 7 days
				//{ "Start": "2025-12-05T03:00:00.000Z", "End": "2025-12-12T16:43:27.739Z", "GroupBy": "day", "RangeName": rangeName },
				//TODO: pass interval caption

				// 30 days
				//{ "Start": "2025-11-12T03:00:00.000Z", "End": "2025-12-12T16:44:11.097Z", "GroupBy": "day" },
				// This month
				//{ "Start": "2025-12-01T03:00:00.000Z", "End": "2025-12-12T16:45:02.888Z", "GroupBy": "day" },
				// Custom
				//{ "Start": "2025-10-01T03:00:00.000Z", "End": "2025-12-26T03:00:00.000Z", "GroupBy": "day" },
				requestPayload,
				{ responseType: 'blob' }
			);
			// Create a blob URL for the iframe
			const blob = new Blob([response.data], { type: 'application/pdf' });
			const url = window.URL.createObjectURL(blob);

			// Clean up previous URL if it exists
			setPdfUrl((prevUrl) => {
				if (prevUrl) {
					window.URL.revokeObjectURL(prevUrl);
				}
				return url;
			});

			setIsLoading(false);
		} catch (error) {
			console.error('Failed to load PDF:', error);
			setIsLoading(false);
		}
	}, [searchParams]);

	useEffect(() => {
		// Load PDF initially
		loadPdf();

		const signalrService = SignalRService.getInstance();

		const handleBackendRestart = () => {
			console.log('Backend restarted, reloading PDF...');
			// Reload PDF when backend restarts
			loadPdf();
		};

		// Listen for backend restart events
		signalrService.on('BackendRestarted', handleBackendRestart);

		// Cleanup on unmount
		return () => {
			signalrService.off('BackendRestarted', handleBackendRestart);
		};
	}, [loadPdf]);

	useEffect(() => {
		// Cleanup PDF URL on unmount
		return () => {
			if (pdfUrl) {
				window.URL.revokeObjectURL(pdfUrl);
			}
		};
	}, [pdfUrl]);

	if (isLoading) {
		return (
			<div className="w-full h-screen flex items-center justify-center">
				<div className="text-lg">Loading PDF...</div>
			</div>
		);
	}

	return (
		<div className="w-full h-screen">
			<iframe
				src={pdfUrl}
				className="w-full h-full border-0"
				title="Insights PDF"
			/>
		</div>
	);
};

export default InsightsPdfViewer;
